import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { toast } from 'react-toastify';
import { MailCheck } from 'lucide-react';
import api from '../utils/api';

export default function ForgotPassword() {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post('/auth/forgot-password', { email });
      setSent(true);
    } catch (err) {
      toast.error(err.response?.data?.error || 'Erreur, réessayez plus tard');
    } finally {
      setLoading(false);
    }
  };

  if (sent) {
    return (
      <div className="auth-page">
        <div className="auth-card card" style={{ textAlign: 'center' }}>
          <MailCheck size={44} color="#16a34a" style={{ margin: '0 auto 14px' }} />
          <h2 style={{ marginBottom: 10 }}>Email envoyé</h2>
          <p style={{ color: 'var(--text-light)', lineHeight: 1.6 }}>
            Si un compte existe avec l'adresse <strong>{email}</strong>,
            un lien de réinitialisation vient de lui être envoyé.<br />
            Le lien est valable 30 minutes.
          </p>
          <p style={{ marginTop: 18, fontSize: '0.9rem' }}>
            <Link to="/login">Retour à la connexion</Link>
          </p>
        </div>
      </div>
    );
  }

  return (
    <div className="auth-page">
      <div className="auth-card card">
        <div style={{ textAlign: 'center', marginBottom: 24 }}>
          <h2 style={{ margin: 0 }}>Mot de passe oublié</h2>
          <p className="auth-subtitle">Recevez un lien de réinitialisation par email</p>
        </div>
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label>Email</label>
            <input type="email" value={email} onChange={e => setEmail(e.target.value)} required autoFocus />
          </div>
          <button className="btn btn-primary" style={{ width: '100%', marginTop: 8 }} disabled={loading}>
            {loading ? 'Envoi...' : 'Envoyer le lien'}
          </button>
        </form>
        <p style={{ textAlign: 'center', marginTop: 16, fontSize: '0.9rem' }}>
          <Link to="/login">Retour à la connexion</Link>
        </p>
      </div>
    </div>
  );
}
